import styled from 'styled-components';
// import palette from '../../lib/styles/palette';

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeField, initializeInput } from '../../modules/conveyor/conveyorWriteSlice';

const ApplyCodeSelectionRadioButtons = ({ conveyorType, applyCode }) => {
    const dispatch = useDispatch();
    const [newType, setNewType] = useState(
        applyCode ||
            (conveyorType === 'Pipe' || conveyorType === 'Return Pipe' ? 'JIS B-8805(Old)' : 'JIS B-8805(New)'),
    );

    const handleChange = (e) => {
        setNewType(e.target.value);
    };

    useEffect(() => {
        dispatch(
            changeField({
                key: 'applyCode',
                value: newType,
            }),
        );

        dispatch(initializeInput());
    }, [dispatch, newType]);

    const typeArray =
        conveyorType === 'Pipe' || conveyorType === 'Return Pipe'
            ? ['JIS B-8805(Old)', 'JIS B-8805(New)' /*, 'CEMA', 'DIN', 'ISO' */]
            : ['JIS B-8805(New)', 'CEMA', 'DIN', 'ISO'];

    return (
        <ApplyCodeSelectionRadioButtonsBlock>
            <form>
                <RadioButtons newType={newType} handleChange={handleChange} typeArray={typeArray} />
            </form>
        </ApplyCodeSelectionRadioButtonsBlock>
    );
};

export default ApplyCodeSelectionRadioButtons;

const RadioButtons = ({ newType, handleChange, typeArray }) => {
    return (
        <div style={{ marginTop: '1rem' }}>
            {typeArray.map((type, index) => (
                <label key={index} style={{ marginRight: '1rem' }}>
                    <input type="radio" value={type} checked={type === newType} onChange={handleChange} />
                    {type}
                </label>
            ))}
        </div>
    );
};

const ApplyCodeSelectionRadioButtonsBlock = styled.div``;
